;(function (angular, numeral) {
  'use strict'

  angular
    .module('kilo', [
      'ui.select',
      'cfp.hotkeys',
      'ui.router',
      'ngSanitize',
      'angularMoment',
      '90TechSAS.zlAuth',
      '90Tech.front-end-services',
      '720kb.tooltips',
      'zlContextMenu',
      'ncy-angular-breadcrumb',
      'rzModule',
      'pusher-angular',
      'gridster',
      'chart.js',
      'ui.bootstrap',
      'angularFileUpload',
      'pusher-angular',
      'colorpicker.module',
      '90TechSAS.date-picker',
      'ng.jsoneditor',
      'ngMessages',
      'http-retryer',

      '90TechSAS.logger',
      '90Tech.coloriage',
      '90TechSAS.entity-service',
      'coloriage.activity',
      'coloriage.interco',

      'kilo.config',
      'kilo.common',
      'kilo.routes'
    ])

  numeral.language('fr')
})(window.angular, window.numeral)
